import { Moment } from 'moment';
import { LabelValue } from '../../library/Types';

export enum CurrentPage {
    FIRST = 'FIRST',
    SECOND = 'SECOND',
    THIRD = 'THIRD',
    FOUR = 'FOUR',
    FIFTH = 'FIFTH',
    SUMMARY = 'SUMMARY',
}

export enum CurrentPageNumber {
    FIRST = 1,
    SECOND = 2,
    THIRD = 3,
    FOUR = 4,
    FIFTH = 5,
    SUMMARY = 6,
}

export enum ButtonAction {
    PREV = 'PREV',
    NEXT = 'NEXT',
    SUBMIT = 'SUBMIT',
    SAVE_DRAFT = 'SAVE_DRAFT',
}

export interface NewConsignmentState {
    currentPage: CurrentPage,
    visited: Record<CurrentPage, boolean>;
}

export type FormField = {
    label: string;
    label2?: string;
    type: InputTypes;
    mode?: 'multiple' | 'tags';
    inputType?: 'text' | 'number';
    key: string;
    titleKey?: string;
    valuePropName: string;
    defaultValue?: string | boolean | Moment | Array<string>;
    defaultValue2?: string | boolean | Moment;
    options?: LabelValue[];
    getOptions?: (master: any) => LabelValue[] | null;
    placeholder?: string;
    placeholder2?: string;
    direction?: 'row' | 'column';
    width?: number | string,
    titleWidth?: string | number;
    disabled?: boolean;
    validate?: boolean;
    required?: boolean;
};

export enum InputTypes {
    Checkbox = 'Checkbox',
    Input = 'Input',
    Select = 'Select',
    Radio = 'Radio',
    Textarea = 'Textarea',
    Date = 'Date',
    Time = 'Time',
    CustomTime = 'CustomTime',
    Number = 'Number',
    Switch = 'Switch',
    Tag = 'Tag',
    TimeSlot = 'TimeSlot',
}
